import { render, staticRenderFns } from "./addGPMModal.vue?vue&type=template&id=2538fb28&"
import script from "./addGPMModal.vue?vue&type=script&lang=js&"
export * from "./addGPMModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports